module.exports = __webpack_public_path__ + "22573ed1fde589c8a456d2e1a12b2685.pdf";